import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EnhancedHeader } from '@/components/EnhancedHeader';
import { LiveMatchTracker } from '@/components/LiveMatchTracker';
import { LiveChallenges } from '@/components/LiveChallenges';
import { MyLiveBets } from '@/components/MyLiveBets';
import { Badge } from '@/components/ui/badge';
import { Radio, Trophy, Flame, Activity } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

export default function LiveGames() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <EnhancedHeader />
      
      <div className="container py-8">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Radio className="h-8 w-8 text-red-500 animate-pulse" />
            <h1 className="text-4xl font-bold">Live Games</h1>
            <Badge className="bg-red-500 text-white animate-pulse">
              LIVE
            </Badge>
          </div>
          <p className="text-xl text-muted-foreground">
            Bet on live matches and compete in real-time challenges
          </p>
        </div>

        <Tabs defaultValue="matches" className="space-y-6">
          <TabsList className="grid w-full max-w-2xl grid-cols-3">
            <TabsTrigger value="matches" className="flex items-center gap-2">
              <Radio className="h-4 w-4" />
              Live Matches
            </TabsTrigger>
            <TabsTrigger value="challenges" className="flex items-center gap-2">
              <Trophy className="h-4 w-4" />
              Challenges
            </TabsTrigger>
            <TabsTrigger value="mybets" className="flex items-center gap-2">
              <Activity className="h-4 w-4" />
              My Bets
            </TabsTrigger>
          </TabsList>

          <TabsContent value="matches" className="space-y-6">
            <LiveMatchTracker />
          </TabsContent>

          <TabsContent value="challenges" className="space-y-6">
            <LiveChallenges />
          </TabsContent>

          <TabsContent value="mybets" className="space-y-6">
            <MyLiveBets />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
